import React, { useState, useEffect } from 'react';

import {
  Condition,
} from "@dndModels";
import DisplayString from '@components/input/strings/DisplayString';

interface Props {
  cond: Condition;
  onAdd: () => void;
  onStar: (id: string) => void;
  onImmune: (id: string) => void;
}

export default function ConditionAddRow({
  cond,
  onAdd,
  onStar,
  onImmune,
}: Props) {
  const [expanded, setExpanded] = useState(false);

  const handleAddCondition = () => {
    onAdd();
  };

  return (
    <div style={{ fontSize: '12px' }}>
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          padding: '5px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.background = '#1976d2'; 
          e.currentTarget.style.color = "#fff";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent'
          e.currentTarget.style.color = "inherit";
        }}
      >
        {cond.use_name}
        <button
          onClick={() => handleAddCondition()}
          style={{
            width: '35px',
            height: '28px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            fontSize: '12px',
            float: "right"
          }}
        >
          Add
        </button>
      </div>
      { expanded &&
        <div style={{ border: "1px solid", padding: "4px" }}>
          <DisplayString str={ cond.description } />
        </div>
      }
    </div>
  );
}